import React from 'react';
import Tabs from 'components/utilities/tabs/Tabs';
import { useSelector } from 'react-redux';

// Import helrpes
import { sectionsTabs } from './helpers/index';

const SectionsTabs = () => {
	const { languages: contentTranslationLanguages } = useSelector(
		({ content_translations }) => content_translations.language_list
	);
	return <Tabs tabs={sectionsTabs(contentTranslationLanguages)} />;
};

export default SectionsTabs;
